import React, { useEffect } from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { Option } = Select;

const UserForm = ({ initialValues, onSubmit, onCancel, loading }) => {
  const [form] = Form.useForm();
  const isEditing = !!initialValues;

  useEffect(() => {
    // Reset fields and set new values when initialValues change
     form.resetFields(); // Clear previous values/errors
     if (initialValues) {
          // Don't set password field when editing unless explicitly needed
          const { password, ...formData } = initialValues;
          form.setFieldsValue(formData);
     } else {
          form.setFieldsValue({ // Defaults for new user
               name: '',
               email: '',
               role: 'viewer', // Default role
               password: '',
          });
     }

  }, [initialValues, form]);

  const handleFinish = (values) => {
    onSubmit(values); // Pass validated values to parent handler
  };

  const userRoles = ['administrator', 'manager', 'viewer']; // Define available roles

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="name"
            label="Full Name"
            rules={[{ required: true, message: 'Please enter the full name' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Full Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: 'Please enter the email address' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email Address" type="email" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
         <Col xs={24} sm={12}>
            <Form.Item
                name="role"
                label="User Role"
                rules={[{ required: true, message: 'Please select a role' }]}
            >
                <Select prefix={<SafetyCertificateOutlined />} placeholder="Select Role">
                {userRoles.map(role => (
                    <Option key={role} value={role} style={{ textTransform: 'capitalize'}}>
                       <SafetyCertificateOutlined style={{ marginRight: 8 }} /> {role}
                    </Option>
                ))}
                </Select>
            </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="password"
            label={isEditing ? "New Password (optional)" : "Password"}
            rules={[{ required: !isEditing, message: 'Password is required for new users' }]} // Required only when adding
            help={isEditing ? "Leave blank to keep the current password" : ""}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={isEditing ? "New Password" : "Password"} />
          </Form.Item>
        </Col>
      </Row>

      {/* Optional: Add confirm password field if needed */}

      <Form.Item style={{ textAlign: 'right', marginTop: '24px' }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }} disabled={loading}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" loading={loading}>
          {isEditing ? 'Save Changes' : 'Add User'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default UserForm;